import { render, staticRenderFns } from "./ModalDetailsWba.vue?vue&type=template&id=8156b010&scoped=true&"
import script from "./ModalDetailsWba.vue?vue&type=script&lang=js&"
export * from "./ModalDetailsWba.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetailsWba.vue?vue&type=style&index=0&id=8156b010&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8156b010",
  null
  
)

export default component.exports